import toast from 'react-hot-toast';
import { useAccount } from 'wagmi';

import { vaultAddress } from 'smart-contracts/addresses';
import { useNFTContract } from 'smart-contracts/contracts';

const contractsWithoutApprove = ['0x3E34ff1790BF0a13EfD7d77e75870Cb525687338'];

const useApproveMiddleware = () => {
  const generateNftContract = useNFTContract();
  const { address } = useAccount();

  const approveNFTMiddleware = async (collectionAddress: string, tokenId: string) => {
    if (contractsWithoutApprove.includes(collectionAddress)) return;
    const NFTContract = generateNftContract(collectionAddress);

    let isApproved;
    const isCryptoKitties = collectionAddress === '0x06012c8cf97BEaD5deAe237070F9587f8E7A266d';
    if (isCryptoKitties) {
      const [approvedAddress] = await NFTContract.functions.kittyIndexToApproved(tokenId);
      isApproved = approvedAddress === vaultAddress;
    } else {
      [isApproved] = await NFTContract.functions.isApprovedForAll(address, vaultAddress);
    }

    const approveSubject = isCryptoKitties ? 'token' : 'collection';

    if (!isApproved) {
      await toast.promise(
        (async () => {
          let approveResponse;
          if (isCryptoKitties) {
            approveResponse = await NFTContract.functions.approve(vaultAddress, tokenId);
          } else {
            approveResponse = await NFTContract.functions.setApprovalForAll(vaultAddress, true);
          }
          await approveResponse.wait();
        })(),
        {
          loading: `Please wait until the ${approveSubject} is approved.`,
          success: `The ${approveSubject} has been successfully confirmed.`,
          error: 'Something went wrong. Please check the MetaMask logs.',
        }
      );
    }
  };

  return { approveNFTMiddleware };
};

export { useApproveMiddleware };
